import { DocumentNode } from "@apollo/client";

import { showDeleteConfirmation } from "components/ApiKeys/DeleteConfirmation";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";

type ApiKeysListItemDropdownProps = {
  handleApiKeyDetailsClick: () => void;
  name: string;
  id: string;
  refetchQueriesOnDelete?: DocumentNode[];
};

const ApiKeysListItemDropdown = ({
  handleApiKeyDetailsClick,
  refetchQueriesOnDelete,
  name,
  id,
}: ApiKeysListItemDropdownProps) => {
  const onDeleteClick = () => {
    showDeleteConfirmation({ name, id, refetchQueriesOnDelete });
  };

  return (
    <DropdownMenuEllipsis tooltip="API key actions">
      <DropdownMenuItem onAction={handleApiKeyDetailsClick}>Access details</DropdownMenuItem>
      <DropdownMenuItem onAction={onDeleteClick} danger>
        Delete
      </DropdownMenuItem>
    </DropdownMenuEllipsis>
  );
};

export default ApiKeysListItemDropdown;
